import React, { forwardRef, useContext } from "react";
import { Link as GatsbyLink } from "gatsby";
import classNames from "classnames";
import { normalizeRelativePath } from "../utility/paths";
import CartContext from "../context/cart";

// Fine tune this on project needs
const INTERNAL_REGEX = new RegExp(`^/(?!/)`);

const GlobalLink = forwardRef(({ to, children, ...props }, ref) => {
  const { isWashpass } = useContext(CartContext);
  // eslint-disable-next-line no-script-url
  if (to === "javascript:Optanon.ToggleInfoDisplay()") {
    const { className, target, ...otherProps } = props;
    return (
      <button
        {...otherProps}
        ref={ref}
        className={classNames("link", className)}
        onClick={() => {
          if (window.Optanon) {
            window.Optanon.ToggleInfoDisplay();
          } else {
            console.warn("window.Optanon not available");
          }
        }}
      >
        {children}
      </button>
    );
  }
  if (
    INTERNAL_REGEX.test(to) &&
    ((isWashpass && /\/washpass/.test(to)) || (!isWashpass && !/\/washpass/.test(to)))
  ) {
    const { className, activeClassName, style, activeStyle } = props;

    // Gestione activeClassName indipendente da slash finale o meno
    const isActive = ({ isPartiallyCurrent, href, location }) => {
      const pathname = location.pathname;
      const strippedHref = href.endsWith("/") ? href.substring(0, href.length - 1) : href;
      const strippedPathname = pathname.endsWith("/")
        ? pathname.substring(0, pathname.length - 1)
        : pathname;
      if (strippedHref === strippedPathname) {
        return {
          className: [className, activeClassName].filter(Boolean).join(" "),
          style: { ...style, ...activeStyle },
        };
      }
      return null;
    };
    const internalLink = to ? normalizeRelativePath(to) : to;
    return (
      <GatsbyLink ref={ref} getProps={isActive} to={internalLink} {...props}>
        <>{children}</>
      </GatsbyLink>
    );
  }
  // Remove activeClassName prop from external links
  const { activeClassName, target, ...other } = props;
  const linkTarget = target
    ? target
    : to?.startsWith("#") || (isWashpass && !/\/washpass/.test(to))
    ? "_self"
    : "_blank";
  return (
    <a ref={ref} href={to} {...other} target={linkTarget} rel="noopener noreferrer">
      <>{children}</>
    </a>
  );
});

export const Link = GlobalLink;
